import Api from './ApiService'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`faq?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`faq/${id}`);
    },
    create(data) {
        return Api().post(`faq`, data);
    },
    update(data) {
        return Api().put(`faq/${data.id}`, data);
    },
    delete(id) {
        return Api().delete(`faq/${id}`);
    }
}